import { authRouter } from '@/router'
import {
  userMyAuth
} from '@/api/user'

function createMenuMap (router) {
  let menuFirst = []
  let menuSecond = {}
  for (let i = 0; i < router.length; i++) {
    if (router[i].meta.name) {
      menuFirst.push({
        name: router[i].meta.name,
        path: router[i].path,
        icon: router[i].meta.icon || ''
      })
      if (router[i].children) {
        const list = []
        for (let j = 0; j < router[i].children.length; j++) {
          if (router[i].children[j].meta.name) {
            list.push({
              name: router[i].children[j].meta.name,
              path: router[i].path + '/' + router[i].children[j].path
            })
          }
        }
        menuSecond[router[i].path] = list
      }
    }
  }
  return { menuFirst: menuFirst, menuSecond: menuSecond }
}

function hasPermission (auth, route) {
  if (!route) {
    return true
  }
  let status = true
  for (let i = 0; i < route.length; i++) {
    if (!status) return
    const item = route[i]
    const value = auth[item] ? auth[item] : '0'
    if (value === '0') {
      status = false
    }
  }
  return status
}

function filterAsyncRouter (asyncRouterMap, auth) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(auth, route.auth)) {
      return true
    }
    return false
  })
  for (let i = 0; i < accessedRouters.length; i++) {
    const router = accessedRouters[i]
    const children = router.children ? router.children : []
    const filterChildren = children.filter(item => {
      if (hasPermission(auth, item.auth)) {
        return true
      }
      return false
    })
    accessedRouters[i].children = filterChildren
  }
  return accessedRouters
}

const permission = {
  state: {
    menuFirst: [],
    menuSecond: [],
    menuPath: {
      name: '',
      path: '',
      pathSecond: ''
    },
    auth: {},
    addRouters: []
  },
  mutations: {
    SET_AUTH: (state, auth) => {
      state.auth = auth
    },
    SET_MENU: (state, menu) => {
      state.menuFirst = menu.menuFirst
      state.menuSecond = menu.menuSecond
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
    },
    SET_MENU_PATH: (state, menu) => {
      state.menuPath = menu
    }
  },
  actions: {
    CreateRouter ({ commit }, auth) {
      return new Promise((resolve, reject) => {
        userMyAuth().then(response => {
          const auth = response.result.auth
          commit('SET_AUTH', auth)
          let accessedRouters = filterAsyncRouter(authRouter, auth)
          commit('SET_ROUTERS', accessedRouters)
          const menu = createMenuMap(accessedRouters)
          commit('SET_MENU', menu)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CreateMenu ({ commit }, matched) {
      return new Promise(resolve => {
        if (!matched[0]) {
          resolve()
          return
        }
        const path = {
          path: matched[0].path,
          name: matched[0].meta.name
        }
        if (matched[1]) {
          path.path_second = matched[1].path
        }
        commit('SET_MENU_PATH', path)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js